// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search_Search__CqEEE","Search_searchErrorText":"Search_Search_searchErrorText__o_jhi"};